package org.moxultimate.topwithmox.pages

import androidx.compose.runtime.Composable
import com.varabyte.kobweb.core.Page
import com.varabyte.kobweb.core.data.add
import com.varabyte.kobweb.core.data.getValue
import com.varabyte.kobweb.core.init.InitRoute
import com.varabyte.kobweb.core.init.InitRouteContext
import com.varabyte.kobweb.core.layout.Layout
import com.varabyte.kobweb.core.rememberPageContext
import org.moxultimate.topwithmox.components.layouts.PageLayoutData
import org.moxultimate.topwithmox.navigation.NavParams
import org.moxultimate.topwithmox.productcrud.update.ProductItemUpdatePage

private data class ProductItemUpdateData(val contentId: Long, val productId: Long)

@InitRoute
fun initProductItemUpdateRoute(ctx: InitRouteContext) {
    ctx.data.add(PageLayoutData("Edit Product"))

    val urlParams: dynamic = js("new URLSearchParams(window.location.search)")
    fun param(key: String): String = (urlParams.get(key) as? String).orEmpty()

    ctx.data.add(ProductItemUpdateData(
        contentId = param(NavParams.CONTENT_ID).toLongOrNull() ?: 0L,
        productId = param(NavParams.PRODUCT_ID).toLongOrNull() ?: 0L,
    ))
}

@Page(routeOverride = "productitemupdate")
@Layout(".components.layouts.PageLayout")
@Composable
fun ProductItemUpdateRoute() {
    val ctx = rememberPageContext()
    val data = ctx.data.getValue<ProductItemUpdateData>()
    ProductItemUpdatePage(contentId = data.contentId, productId = data.productId)
}
